// extracted by mini-css-extract-plugin
export var contentBody = "_dq-9";
export var headerImage = "_dq-2";
export var imageButton = "_dq-7";
export var imageButtonIcon = "_dq-8";
export var imageHeader = "_dq-4";
export var imageHeaderText = "_dq-5";
export var imageOverlay = "_dq-3";
export var imageTitle = "_dq-6";
export var imageWrapper = "_dq-1";
export var taskList = "_dq-a";
export var widget = "_dq-0";